import React from 'react'
import PropTypes from 'prop-types'


// const initialState = {
//   raw_leagal_data: {
//       hb_usage: { hb_usage: 1 },
//       occupation_activity: { occupation_activity: 1 },
//       income: { income: 1 },
//       income_source: { income_source: "" },
//       fiscal_residence: { fiscal_residence: 1 },
//       has_us_address: { has_us_address: 0 },
//       is_us_citizen: { is_us_citizen: 0 },
//       PEP: { pep: 0 },
//       ubo: { ubo: 1 },
//       join_reason: { join_reason: "" },
//       idcard: {
//           front: {
//               mediaId: "",
//               fileName: "",
//               fileBody: ""
//             },
//           back: {
//               mediaId: "",
//               fileName: "",
//               fileBody: ""
//             }
//         }
//     },
//   raw_personal_data: {
//       identity: { first_name: "", last_name: "" },
//       email: { email: "", optin_email: 0 },
//       phone: { internal_mobile_country_code: "", __internal_mobile_country_calling_code: "", internal_mobile_phone_number: "", optin_mobile: 0 },
//       belgium_resident: { belgium_resident: 1 },
//       legalAddress: { street: "", house_number: "", box: "", "__postal-input": "" },
//       dateOfBirth: { birthday: "" },
//       placeOfBirth: { birth_country: "", __country: "", __postal_input: "", birth_place: "" },
//       nationality: { nationality: "", __country: { birth_country: { callingCode: "", code: "", name: "" } } },
//       civil_state: { civil_state: 1 }
//     },
//   raw_pro_data: {
//       has_enterprise: { has_enterprise: 1 },
//       enterprise_number: { enterprise_number: "" },
//       enterprise_name: { enterprise_name: "" },
//       establishment_date: { establishment_date: "" },
//       enterprise_activity_code: { enterprise_activity_code: "", __selectionTree: [], __name: "" },
//       enterprise_activity_country: { enterprise_activity_country: "", __country: { birth_country: { callingCode: "", code: "", name: "" } } }
//     },
//   end_flow: { title: "", description: "" },
//     RESET_CONTEXT: () => {}
// };
const initialState = {
  raw_personal_data: {},
  raw_leagal_data: {},
  raw_pro_data: {},
  end_flow: { title: "", description: "" },
    RESET_CONTEXT: () => { },
  footer_height: 48
};

export const AppDataContext = React.createContext(initialState);

function reducer(state, action) {
    switch (action.type) {
        case 'SET_RAW_PERSONAL_DATA':
            return {
                ...state,
                raw_personal_data: {
                    ...state.raw_personal_data,
                    [action.step.step_ID]:{
                        ...state.raw_personal_data[action.step.step_ID],
                        ...action.value,
                    }
                }
            };
        
        case 'SET_RAW_LEGAL_DATA':
            return {
                ...state,
                raw_leagal_data: {
                    ...state.raw_leagal_data,
                    [action.step.step_ID]:{
                        ...state.raw_leagal_data[action.step.step_ID],
                        ...action.value,
                    }
                }
            };
        
        case 'SET_RAW_PRO_DATA':
            return {
                ...state,
                raw_pro_data: {
                    ...state.raw_pro_data,
                    [action.step.step_ID]:{
                        ...state.raw_pro_data[action.step.step_ID],
                        ...action.value,
                    }
                }
            };
        
        
        case 'SET_PERSONAL_DATA':
            return {
                ...state,
                personal_data: {
                    ...state.personal_data,
                    [action.step.step_ID]:{
                        ...state.personal_data[action.step.step_ID],
                        ...action.value,
                        step:{
                            step_position: action.step.step_position,
                            step_ID : action.step.step_ID,
                            step_URL : action.step.step_URL,
                        }
                    }
                }
            };
        
        case 'SET_LEGAL_DATA':
            return {
                ...state,
                legal_data: {
                    ...state.legal_data,
                    [action.step.step_ID]:{
                        ...state.leagal_data[action.step.step_ID],
                        ...action.value,
                        step:{
                            step_position: action.step.step_position,
                            step_ID : action.step.step_ID,
                            step_URL : action.step.step_URL,
                        }
                    }
                }
            };
        
         case 'SET_PRO_DATA':
            return {
                ...state,
                pro_data: {
                    ...state.pro_data,
                    [action.step.step_ID]:{
                        ...state.pro_data[action.step.step_ID],
                        ...action.value,
                        step:{
                            step_position: action.step.step_position,
                            step_ID : action.step.step_ID,
                            step_URL : action.step.step_URL,
                        }
                    }
                }
            };
        
        case 'SET_END_FLOW_MESSAGE':
            return { ...state, end_flow: action.end_flow };
        
                case 'SET_FOOTER_HEIGHT':
            return {
                ...state,
                footer_height: action.value
            };
        case 'RESET_CONTEXT':
            return initialState;
        
        default:
            return state;
    }
}
export function AppDataContextProvider(props) {
    const [state, dispatch] = React.useReducer(reducer, initialState);
    const value = { state, dispatch };
    return (
        <AppDataContext.Provider value={value}>
            {props.children}
        </AppDataContext.Provider>
    )
}

AppDataContextProvider.propTypes = {
    children: PropTypes.node
};
